module.exports = __webpack_public_path__ + "static/media/Geomanist-Black.0c056df6.otf";